import { render, staticRenderFns } from "./setStaffPermissions.vue?vue&type=template&id=747e03ca&scoped=true&"
import script from "./setStaffPermissions.vue?vue&type=script&lang=js&"
export * from "./setStaffPermissions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "747e03ca",
  null
  
)

export default component.exports